import React from "react";

const HeadAccordion = ({children}) => {
    return (
        <React.Fragment>
            { children }
        </React.Fragment>
    );
}

export default HeadAccordion;